import { t } from 'i18next';
import { RouteObject } from 'react-router-dom';
import { BaseOutlet } from '../../../components/BaseOutlet/BaseOutlet';
import { SetupClassesAndDivisions } from './ClassesAndDivisions/SetupClassesAndDivisions';
import { curriculumVersionRoutes } from './CurriculumVersions/routes';
import { DeputateSetupPage } from './DeputateSetupPage';
import { FactorsPage } from './Factors/FactorsPage';
import { SetupPersons } from './Persons/SetupPersons';
import { SetupRoomsAndBuildings } from './RoomsAndBuildings/SetupRoomsAndBuildings';
import { DeputateSetupSubjectsAndSubjectContainer } from './SubjectsAndSubjectContainer/DeputateSetupSubjectsAndSubjectContainer';

export const deputateSetupRoutes = (baseSlug: string): RouteObject[] => {
  return [
    {
      index: true,
      element: <DeputateSetupPage />,
    },
    {
      path: t('routes.subjects.slug'),
      element: <DeputateSetupSubjectsAndSubjectContainer />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.subjects.slug')}`,
          title: t('routes.subjects.title'),
        }),
      },
    },
    {
      path: t('routes.teacher.slug'),
      element: <SetupPersons />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.teacher.slug')}`,
          title: t('routes.teacher.title'),
        }),
      },
    },
    {
      path: t('routes.classes.slug'),
      element: <SetupClassesAndDivisions />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.classes.slug')}`,
          title: t('routes.classes.title'),
        }),
      },
    },
    {
      path: t('routes.rooms.slug'),
      element: <SetupRoomsAndBuildings />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.rooms.slug')}`,
          title: t('routes.rooms.title'),
        }),
      },
    },
    {
      path: t('routes.factors.slug'),
      element: <FactorsPage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.factors.slug')}`,
          title: t('routes.factors.title'),
        }),
      },
    },
    {
      path: t('routes.curriculum.slug'),
      element: <BaseOutlet />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.curriculum.slug')}`,
          title: t('curriculumVersion.title', { count: 2 }),
        }),
      },
      children: [...curriculumVersionRoutes(baseSlug)],
    },
  ];
};
